// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__KoBUE","wrapper":"Tooltip_wrapper__BpzJM","action__btn":"Tooltip_action__btn__JTSz1"};